import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserPlus, FaLayerGroup, FaMoneyBillWave, FaCog } from 'react-icons/fa';

export default function QuickActions({ pendingCount }) {
    const navigate = useNavigate();

    const actions = [
        {
            title: 'Add Student',
            icon: <FaUserPlus />,
            color: 'bg-blue-600',
            link: '/dashboard/users'
        },
        {
            title: 'Manage Classes',
            icon: <FaLayerGroup />,
            color: 'bg-purple-600',
            link: '/dashboard/admin/classes'
        },
        {
            title: 'Approvals',
            icon: <FaMoneyBillWave />,
            color: 'bg-orange-600',
            link: '/dashboard/admin/payments',
            badge: pendingCount
        },
        {
            title: 'Settings',
            icon: <FaCog />,
            color: 'bg-gray-600',
            link: '/dashboard/admin/settings'
        }
    ];

    return (
        <div className="bg-white/60 backdrop-blur-xl rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-white/50 p-6 h-full">
            <h2 className="text-lg font-bold text-gray-900 mb-6">Quick Actions</h2>
            <div className="grid grid-cols-2 gap-4">
                {actions.map((action, idx) => (
                    <button
                        key={idx}
                        onClick={() => navigate(action.link)}
                        className="flex flex-col items-center justify-center p-4 rounded-xl bg-white border border-gray-100 shadow-sm hover:shadow-md hover:bg-gray-50 transition-all duration-300 group"
                    >
                        <div className={`w-10 h-10 rounded-full ${action.color} text-white flex items-center justify-center text-lg mb-3 shadow-lg group-hover:scale-110 transition-transform relative`}>
                            {action.icon}
                            {action.badge > 0 && (
                                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] w-5 h-5 flex items-center justify-center rounded-full border-2 border-white font-bold">
                                    {action.badge}
                                </span>
                            )}
                        </div>
                        <span className="text-sm font-bold text-gray-700 group-hover:text-gray-900">{action.title}</span>
                    </button>
                ))}
            </div>

            {/* System Status - Mini Widget */}
            <div className="mt-6 pt-6 border-t border-gray-100">
                <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-500 font-medium">System Status</span>
                    <span className="flex items-center gap-2 text-green-600 font-bold bg-green-50 px-2 py-1 rounded-lg">
                        <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                        Operational
                    </span>
                </div>
            </div>
        </div>
    );
}
